"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configurePlainStore;
var _redux = require("redux");
var _reduxLogger = require("redux-logger");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const enhancedCompose = process.env.NODE_ENV !== 'production' && process.env.BROWSER && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
const middlewareBuilder = (additionalMiddlewares, loggerOption) => {
  let middleware = {};
  let allComposeElements = [];
  const universalMiddleware = [...additionalMiddlewares];
  if (process.env.NODE_ENV === 'production') {
    middleware = (0, _redux.applyMiddleware)(...universalMiddleware);
    allComposeElements = [middleware];
  } else {
    const opt = _objectSpread({
      collapsed: true
    }, loggerOption);
    middleware = (0, _redux.applyMiddleware)(...universalMiddleware, (0, _reduxLogger.createLogger)(opt));
    allComposeElements = [middleware];
  }
  return allComposeElements;
};
function configurePlainStore(rootReducer, initialState, additionalMiddlewares = [], loggerOption = {}) {
  const finalCreateStore = enhancedCompose(...middlewareBuilder(additionalMiddlewares, loggerOption))(_redux.createStore);
  const store = finalCreateStore(rootReducer, initialState);
  return store;
}